import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0168d8e8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", {
    class: "border-0 h-100 w-100",
    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectFile && _ctx.selectFile(...args)))
  }, [
    _createVNode("input", {
      hidden: "true",
      ref: "input",
      type: "file",
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
      multiple: "false"
    }, null, 544)
  ]))
})